export class LossSummary {
    total: number;
    totalSalaries: number;
    totalInventory: number;
    totalOthers: number;

    constructor(pExpenses: number, pCostGoods: number, pInventory: number, pSalary: number ) {
        this.totalInventory = pInventory;
        this.totalSalaries = pSalary;
        this.totalOthers = pExpenses + pCostGoods;
        this.total = this.totalInventory + this.totalSalaries + this.totalOthers;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/shared/models/loss-summary.ts